import { compare } from 'semver'
import Vue, { computed } from 'vue'
import Router from 'vue-router'
import Layout from '../layout'
import { resolve } from 'q'

// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // }
    {
      path: '/login',
      name: '登录页面',
      component: (resolve) => require(['../views/login.vue'], resolve)
    },
    {
      path: '/registrationPage',
      name: '注册',
      component: (resolve) => require(['../views/registrationPage.vue'], resolve)
    },
    {
      path: '/resetPasswordPage',
      name: '修改密码',
      component: (resolve) => require(['../views/resetPasswordPage.vue'], resolve)
    },
    {
      path: '/modifyMobilePhone',
      name: '修改手机号',
      component: (resolve) => require(['../views/modifyMobilePhone.vue'], resolve)
    },
    {
      path: '/personality',
      name: 'H5个性标签',
      component: (resolve) => require(['../views/personality.vue'], resolve),
    },
    {
      path: '/personalityLabel',
      name: 'H5个性标签汇总',
      component: (resolve) => require(['../views/personalityLabel.vue'], resolve),
    },
    {
      path: '/',
      name: '首页',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          name: '首页',
          component: (resolve) => require(['../views/home.vue'], resolve),
        },
        {
          path: '/chargingStandards',
          name: '收费标准',
          component: (resolve) => require(['../views/chargingStandards.vue'], resolve),
        },
        {
          path: '/ratingCriteria',
          name: '评级标准',
          component: (resolve) => require(['../views/ratingCriteria.vue'], resolve),
        },
        {
          path: '/submitComments',
          name: '我要送评',
          component: (resolve) => require(['../views/submitComments.vue'], resolve),
        },
        {
          path: '/premiumCisplay',
          name: '臻品展示',
          component: (resolve) => require(['../views/premiumCisplay.vue'], resolve),
        },
        {
          path: '/companyOverview',
          name: '公司概括',
          component: (resolve) => require(['../views/companyOverview.vue'], resolve),
        },
        {
          path: '/ratingQuery',
          name: '评级查询页面',
          component: (resolve) => require(['../views/ratingQuery.vue'], resolve)
        },
        {
          path: '/contactUs',
          name: '联系我们',
          component: (resolve) => require(['../views/contactUs.vue'], resolve),
        },
        {
          path: '/notice',
          name: '评级公告',
          component: (resolve) => require(['../views/notice.vue'], resolve),
        },
        {
          path: "/culturalAndCreative",
          name: '邮票文创页面',
          component: (resolve) => require(['../views/culturalAndCreative.vue'], resolve)
        },
        {
          path: '/detailsCultural',
          name: '文创详情页面',
          component: (resolve) => require(['../views/detailsCultural.vue'], resolve)
        },
        {
          path: '/informationDetails',
          name: '资讯中心',
          component: (resolve) => require(['../views/informationDetails.vue'], resolve),
        },
        {
          path: '/collectionList',
          name: '藏品一览',
          component: (resolve) => require(['../views/collectionList.vue'], resolve),
        },
        {
          path: '/collectionDetails',
          name: '藏品详情',
          component: (resolve) => require(['../views/collectionDetails.vue'], resolve),
        },
        {
          path: '/personalCenter',
          name: '个人中心',
          component: (resolve) => require(['../views/personalCenter.vue'], resolve),
        },
        {
          path: '/reviewDetails',
          name: '订单详情',
          component: (resolve) => require(['../views/reviewDetails.vue'], resolve),
        },{
          path:'/customTag',
          name:'个性标签',
          component:(resolve)=>require(['../views/customTag.vue'],resolve),
        },{
          path:'/customTagInfo',
          name:'个性标签详情',
          component:(resolve)=>require(['../views/customTagInfo.vue'],resolve),
        }
      ]
    },

  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js